export const chamWeekdays = [
  { latin: "Adit", cham: "ꨀꨕꨪꩅ", vietnamese: "Chủ nhật", audioKey: "weekday-adit" },
  { latin: "Thom", cham: "ꨔꨯꩌ", vietnamese: "Thứ hai", audioKey: "weekday-thom" },
  { latin: "Angar", cham: "ꨀꨋꩉ", vietnamese: "Thứ ba", audioKey: "weekday-angar" },
  { latin: "But", cham: "ꨝꨭꩅ", vietnamese: "Thứ tư", audioKey: "weekday-but" },
  { latin: "Jip", cham: "ꨎꨪꩇ", vietnamese: "Thứ năm", audioKey: "weekday-jip" },
  { latin: "Suk", cham: "ꨦꨭꩀ", vietnamese: "Thứ sáu", audioKey: "weekday-suk" },
  { latin: "Sanacar", cham: "ꨧꨗꨌꩉ", vietnamese: "Thứ bảy", audioKey: "weekday-sanacar" }
] as const;
